import baseAPI from '@/http'

const router = 'api/governanca'

export const governancaApi = {
    create: (governanca) => baseAPI.post(router, governanca),
    update: (governanca) => baseAPI.put(router, governanca),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-governanca-por-municipio/${municipioId}`),
}
